export default {
  employees: [],
  muckTypes: [],
  equipments: [],
  locations: [],
  timesheets: [],
  forecasts:[],
  mucks:[],
  haulings:[],
  forecastStats:null,
  forecastStatsList:[],
  samples:[],
  forecastPeriodList:[],
  limsSamples:[],
  materialSubTypes:[],
  destinations: [],
  remuckForecasts: [],
  nsrForecasts: []
}
